import { Link } from "react-router-dom";

import SocialLinks from "../components/social-links";
import { Button } from "../components/ui/button";
import { usePageMeta } from "../lib/use-page-meta";

function About() {
  usePageMeta({
    title: "About",
    description:
      "A personal notebook about things I'm learning, small hobbies, and everyday life. Jitra, Kedah is my hometown.",
    path: "/about",
  });

  return (
    <div className="container py-14 md:py-20">
      <div className="grid items-start gap-12 md:grid-cols-[1fr_0.7fr]">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">
            About
          </p>
          <h1 className="mt-2 font-serif text-4xl font-semibold tracking-tight sm:text-5xl">
            Hi, I&apos;m Aiman.
          </h1>

          <div className="mt-6 space-y-4 text-lg leading-8 text-foreground/80">
            <p>
              Jitra, Kedah is my hometown. This site is my personal notebook: a place for
              things I&apos;m learning, small hobbies, and the quiet parts of everyday
              life.
            </p>
            <p>
              I&apos;m not a professional developer, programmer, or tech expert. I just
              like tinkering with websites, taking photos, keeping a small aquarium, and
              reading more than I probably should. Most of what I write here is me
              thinking out loud, not a tutorial.
            </p>
            <p>
              I keep the rest of my life private. There is no publishing schedule. When
              something feels worth keeping, it gets a page.
            </p>
          </div>

          <div className="mt-8 rounded-xl border bg-secondary/50 p-6">
            <h2 className="font-serif text-xl font-semibold tracking-tight">
              What you will find here
            </h2>
            <ul className="mt-3 space-y-2 text-sm leading-6 text-muted-foreground">
              <li>Notes from things I&apos;m learning, usually as a beginner.</li>
              <li>Short essays about attention, habits, and slow progress.</li>
              <li>Stories and photos from home.</li>
            </ul>
            <p className="mt-4 text-sm leading-6 text-muted-foreground">
              Also: two domain names are looking for a new owner.{" "}
              <Link to="/domains" className="font-medium text-primary underline underline-offset-4">
                See the domains
              </Link>
              .
            </p>
          </div>
        </div>

        <div className="relative mx-auto w-full max-w-[180px] md:sticky md:top-24">
          <div
            aria-hidden="true"
            className="absolute -inset-3 rotate-2 rounded-[1.75rem] bg-secondary"
          />
          <img
            src="/assets/aiman-portrait.jpg"
            alt="Portrait of Aiman"
            width="800"
            height="800"
            className="relative aspect-square w-full rounded-[1.5rem] object-cover shadow-lg"
          />
        </div>
      </div>

      <section
        id="contact"
        className="mx-auto mt-16 max-w-3xl scroll-mt-24 border-t pt-10"
      >
        <h2 className="font-serif text-3xl font-semibold tracking-tight">Say hello</h2>
        <p className="mt-3 max-w-2xl leading-7 text-muted-foreground">
          I like hearing from people, but please don&apos;t ask me for technical advice,
          code reviews, or career help. I&apos;m not an expert and I won&apos;t pretend to
          be. If you just want to say hello or share something you liked, find me here. I
          read everything, even if I reply slowly.
        </p>
        <div className="mt-6 flex flex-wrap items-center gap-3">
          <SocialLinks />
          <Button asChild variant="ghost">
            <Link to="/articles">Read the articles</Link>
          </Button>
        </div>
      </section>
    </div>
  );
}

export default About;
